// --- Product Configuration Columns
import * as productsColumns from '../../../pages/Products/components/grid/config/columns';
// --- Rights Configuration Columns
import * as rightsColumns from '../../../pages/Rights/components/grid/config/columns';
// --- Jobs Configuration Columns
import * as jobsColumns from '../../../pages/Jobs/components/grid/config/columns';
// --- Job Metrics Configuration Columns
import * as jobMetricsColumns from '../../../pages/Jobs/components/modals/metrics/grid/config/columns';
// --- Job Tasks Configuration Columns
import * as jobTasksColumns from '../../../pages/Jobs/components/modals/tasks/grid/config/columns';
// --- Date Math Jobs Configuration Columns
import * as dateMathJobsColumns from '../../../pages/DateMath/components/grid/config/columns';
// --- Date Math Calculations Configuration Columns
import * as dateMathCalculationsColumns from '../../../pages/DateMath/components/modal/calculations/grid/config/columns';
// --- Deal Version Configuration Columns
import * as dealVersionColumns from '../../../pages/DealVersion/components/grid/config/columns';
// --- PMX Deliveries Columns
import * as pmxDeliveriesColumns from '../../../pages/PMXDeliveries/components/grid/config/columns';
// --- Users Columns
import * as usersColumns from '../../../pages/Users/components/grid/config/columns';
// --- Saved Template Columns
import * as savedTemplateColumns from '../../../pages/UploadTemplates/components/modals/saved-templates/grid/config/columns';
// --- Product Updates Columns
import * as productUpdatesColumns from '../../../pages/RightslineProductGate/components/grid/config/columns';
// --- Deal DRO Changes Columns
import * as dealDROChangesColumns from '../../../pages/DealDROChanges/components/grid/config/columns';
// --- Ready Products Columns
import * as readyProductsColumns from '../../../pages/Products/components/modal/grid/config/columns';

export const products = (onOpenDetailsDrawer) => ({
    default: [
        productsColumns.sid,
        productsColumns.productId,
        productsColumns.uuid,
        productsColumns.releaseDate,
        productsColumns.title,
        productsColumns.type,
        productsColumns.runTime,
        productsColumns.rlLoadStatus,
        productsColumns.details(onOpenDetailsDrawer),
    ],
});

export const dateMathJobs = (
    onOpenDateMathCalculations,
    startJobAction,
    deleteJobAction,
) => ({
    default: [
        dateMathJobsColumns.statusIndicator,
        dateMathJobsColumns.id,
        dateMathJobsColumns.spaJobStatus,
        dateMathJobsColumns.spaJobType,
        dateMathJobsColumns.targetCount(
            onOpenDateMathCalculations,
        ),
        dateMathJobsColumns.progressCount,
        dateMathJobsColumns.errorCount,
        dateMathJobsColumns.startedByUser,
        dateMathJobsColumns.createdAt,
        dateMathJobsColumns.completedAt,
        dateMathJobsColumns.actions(
            startJobAction,
            deleteJobAction,
        ),
    ],
});

export const dateMathCalculations = (
    onDeleteDateMathCalculation
) => ({
    default: [
        dateMathCalculationsColumns.id,
        dateMathCalculationsColumns.sourceRightslineId,
        dateMathCalculationsColumns.catalogId,
        dateMathCalculationsColumns.status,
        dateMathCalculationsColumns.message,
        dateMathCalculationsColumns.description,
        dateMathCalculationsColumns.type,
        dateMathCalculationsColumns.dateMathTypeTerms,
        dateMathCalculationsColumns.termStart,
        dateMathCalculationsColumns.termEnd,
        dateMathCalculationsColumns.createdAt,
        dateMathCalculationsColumns.action(
            onDeleteDateMathCalculation,
        ),
    ],
});

export const jobs = (onOpenJobTasksModal) => ({
    default: [
        jobsColumns.statusIndicator,
        jobsColumns.id,
        jobsColumns.spaJobType,
        jobsColumns.spaJobStatus,
        jobsColumns.targetCount(
            onOpenJobTasksModal,
        ),
        jobsColumns.progressCount,
        jobsColumns.errorCount,
        jobsColumns.startedByUser,
        jobsColumns.createdAt,
        jobsColumns.completedAt,
    ],
});

export const jobMetrics = () => ({
    default: [
        jobMetricsColumns.id,
        jobMetricsColumns.jobType,
        jobMetricsColumns.jobRuns,
        jobMetricsColumns.targetCount,
        jobMetricsColumns.totalMinutesToComplete,
        jobMetricsColumns.maxMinutesToComplete,
        jobMetricsColumns.avgMinutesToComplete,
        jobMetricsColumns.avgSecondsPerTarget,
        jobMetricsColumns.errorRate,
        jobMetricsColumns.createdAt,
    ],
});

export const jobTasks = () => ({
    default: [
        jobTasksColumns.id,
        jobTasksColumns.taskStatus,
        jobTasksColumns.taskDetails,
        jobTasksColumns.statusMessage,
        jobTasksColumns.createdAt,
        jobTasksColumns.modifiedAt,
        jobTasksColumns.completedAt,
    ],
});

export const rights = (onOpenAssociateDrawer) => ({
    default: [
        rightsColumns.id,
        rightsColumns.rightId,
        rightsColumns.rightTitle,
        rightsColumns.rightTemplate,
        rightsColumns.rightMedia,
        rightsColumns.rightTerritory,
        rightsColumns.rightLanguage,
        rightsColumns.actualTermStart,
        rightsColumns.actualTermEnd,
        rightsColumns.startDateStatus,
        rightsColumns.endDateStatus,
        rightsColumns.dealId,
        rightsColumns.catalogId,
        rightsColumns.dealRecentlyAssociated,
        rightsColumns.catalogRecentlyAssociated,
        rightsColumns.associate(onOpenAssociateDrawer),
        rightsColumns.rightCreated,
    ],
    limited: [
        rightsColumns.id,
        rightsColumns.rightId,
        rightsColumns.rightTitle,
        rightsColumns.rightTemplate,
        rightsColumns.rightMedia,
        rightsColumns.rightTerritory,
        rightsColumns.rightLanguage,
        rightsColumns.actualTermStart,
        rightsColumns.actualTermEnd,
        rightsColumns.startDateStatus,
        rightsColumns.endDateStatus,
        rightsColumns.dealId,
        rightsColumns.catalogId,
        rightsColumns.dealRecentlyAssociated,
        rightsColumns.catalogRecentlyAssociated,
        rightsColumns.rightCreated,
    ]
});

export const dealVersions = (downloadPDF, downloadXLSX, onDeleteSnapshot, isReadOnly) => ({
    default: [
        dealVersionColumns.id,
        dealVersionColumns.version,
        dealVersionColumns.snapshot,
        dealVersionColumns.title,
        dealVersionColumns.template,
        dealVersionColumns.pdf(downloadPDF),
        dealVersionColumns.xlsx(downloadPDF, downloadXLSX),
        dealVersionColumns.created,
        dealVersionColumns.deleteSnapshot(onDeleteSnapshot, isReadOnly),
    ],
});

export const pmxDeliveries = () => ({
    default: [
        pmxDeliveriesColumns.id,
        pmxDeliveriesColumns.action,
        pmxDeliveriesColumns.status,
        pmxDeliveriesColumns.pmxSkuId,
        pmxDeliveriesColumns.productId,
        pmxDeliveriesColumns.releaseId,
        pmxDeliveriesColumns.name,
        pmxDeliveriesColumns.type,
        pmxDeliveriesColumns.territory,
        pmxDeliveriesColumns.releaseDate,
        pmxDeliveriesColumns.error,
        pmxDeliveriesColumns.created,
        pmxDeliveriesColumns.modified,
    ],
});

export const users = () => ({
    default: [
        usersColumns.id,
        usersColumns.username,
        usersColumns.fullName,
        usersColumns.lastLogin,
        usersColumns.status,
        usersColumns.spaUserRoleIds,
        usersColumns.rightslineId,
    ],
});

export const templates = (onLoadTemplate, onDeleteTemplate) => ({
    default: [
        savedTemplateColumns.name,
        savedTemplateColumns.action,
        savedTemplateColumns.module,
        savedTemplateColumns.template,
        savedTemplateColumns.dateFormat,
        savedTemplateColumns.fields,
        savedTemplateColumns.createdAt,
        savedTemplateColumns.updatedAt,
        savedTemplateColumns.functions(onLoadTemplate, onDeleteTemplate),
    ],
});

export const productUpdates = (onAddProducts, onChangeIgnoreFlag) => ({
    default: [
        productUpdatesColumns.action(onAddProducts),
        productUpdatesColumns.message,
        productUpdatesColumns.id,
        productUpdatesColumns.title,
        productUpdatesColumns.groupId,
        productUpdatesColumns.productId,
        productUpdatesColumns.productNumber,
        productUpdatesColumns.episodeTitle,
        productUpdatesColumns.episodeNumber,
        productUpdatesColumns.rightslineId,
        productUpdatesColumns.actedOnDate,
        productUpdatesColumns.actedOnBy,
        productUpdatesColumns.updatedDate,
        productUpdatesColumns.ignore(onChangeIgnoreFlag),
    ],
    limited: [
        productUpdatesColumns.message,
        productUpdatesColumns.id,
        productUpdatesColumns.title,
        productUpdatesColumns.groupId,
        productUpdatesColumns.productId,
        productUpdatesColumns.productNumber,
        productUpdatesColumns.episodeTitle,
        productUpdatesColumns.episodeNumber,
        productUpdatesColumns.rightslineId,
        productUpdatesColumns.actedOnDate,
        productUpdatesColumns.actedOnBy,
        productUpdatesColumns.updatedDate,
    ]
});

export const dealDROChanges = () => ({
    default: [
        dealDROChangesColumns.entityId,
        dealDROChangesColumns.action,
        dealDROChangesColumns.timestamp,
        dealDROChangesColumns.timestampPDT,
        dealDROChangesColumns.catalogId,
        dealDROChangesColumns.catalogName,        
        dealDROChangesColumns.initialReleaseDate,
        dealDROChangesColumns.releasingCompany,
        dealDROChangesColumns.runtimeInMins,
        dealDROChangesColumns.originalLanguage,
        dealDROChangesColumns.termStart,
        dealDROChangesColumns.termEnd, 
        dealDROChangesColumns.media,
        dealDROChangesColumns.territory,
        dealDROChangesColumns.language,
        dealDROChangesColumns.description,
        dealDROChangesColumns.format,        
    ],
});

export const readyProducts = () => ({
    default: [
        readyProductsColumns.productId,
        readyProductsColumns.productTitle,
        readyProductsColumns.releaseDate,
        readyProductsColumns.productClass,
    ],
});